import "./AreaSeparator.css";

export const AreaSeparator = () => {
    return <hr className="area-separator" />;
};
